<div class="m-content">
  <div class="row">
    <div class="col-sm-12">
      <div class="m-portlet m-portlet--full-height">
        <div class="m-portlet__body">
          @if (im) {
            <div class="table-responsive m-datatable--va-top m-datatable m-datatable--default m-datatable--loaded m--margin-top-30 m--margin-bottom-30">
              <table class="m-datatable__table">
                <thead class="m-datatable__head">
                <tr class="m-datatable__row m-datatable__row--head">
                  <th class="m-datatable__cell">{{ 'inventory-management.table.name' | transloco }}</th>
                  <th class="m-datatable__cell">{{ 'inventory-management.table.unitOfMeasure' | transloco }}</th>
                  <th class="m-datatable__cell">{{ 'inventory-management.table.receive' | transloco }}</th>
                  <th class="m-datatable__cell">{{ 'inventory-management.table.receiveTotal' | transloco }}</th>
                  <th class="m-datatable__cell">{{ 'inventory-management.table.export' | transloco }}</th>
                  <th class="m-datatable__cell">{{ 'inventory-management.table.exportTotal' | transloco }}</th>
                  <th class="m-datatable__cell">{{ 'inventory-management.table.inventoryWriteOff' | transloco }}</th>
                  <th class="m-datatable__cell">{{ 'inventory-management.table.inventoryWriteOffTotal' | transloco }}</th>
                  <th class="m-datatable__cell">{{ 'inventory-management.table.inventory' | transloco }}</th>
                  <th class="m-datatable__cell">{{ 'inventory-management.table.inventoryTotal' | transloco }}</th>
                </tr>
                </thead>
                <tbody class="m-datatable__body">
                <tr class="m-datatable__row">
                  <td class="m-datatable__cell">{{ im.productInfoTitle | uiLabel }}</td>
                  <td class="m-datatable__cell">{{ im.unitOfMeasure.title | uiLabel }}</td>
                  <td class="m-datatable__cell">
                    <a
                      routerLink="../invoice-info" [queryParams]="{
                              productInfoId: im.productInfoId, dateFrom: params.date.from, dateTo: params.date.to, storeId: params.storeId, type: 'Import'
                            }"
                      class="link-details">
                      {{ im.receive }}
                    </a>
                  </td>
                  <td class="m-datatable__cell">{{ im.totalReceive }}</td>
                  <td class="m-datatable__cell">
                    <a
                      routerLink="../invoice-info" [queryParams]="{
                              productInfoId: im.productInfoId, dateFrom: params.date.from, dateTo: params.date.to, storeId: params.storeId, type: 'Export'
                            }"
                      class="link-details">
                      {{ im.export }}
                    </a>
                  </td>
                  <td class="m-datatable__cell">{{ im.totalExport }}</td>
                  <td class="m-datatable__cell">
                    <a
                      routerLink="../invoice-info" [queryParams]="{
                              productInfoId: im.productInfoId, dateFrom: params.date.from, dateTo: params.date.to, storeId: params.storeId, type: 'InventoryWriteOff'
                            }"
                      class="link-details">
                      {{ im.inventoryWriteOff }}
                    </a>
                  </td>
                  <td class="m-datatable__cell">{{ im.totalInventoryWriteOff }}</td>
                  <td class="m-datatable__cell">
                    <a
                      routerLink="../invoice-info" [queryParams]="{
                              productInfoId: im.productInfoId, dateFrom: params.date.from, dateTo: params.date.to, storeId: params.storeId, type: 'Inventory'
                            }"
                      class="link-details">
                      {{ im.inventory }}
                    </a>
                  </td>
                  <td class="m-datatable__cell">{{ im.totalInventory }}</td>
                </tr>
                </tbody>
              </table>
            </div>
          }
        </div>
      </div>
    </div>
  </div>
</div>

